import React from 'react';
import classnames from 'classnames';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import TextTooltipOnHover from '../Popover/Preset/TextTooltipOnHover';
import tagStyle from './Tags.scss';
export var Tag = function (_a) {
    var tag = _a.tag, isOverflow = _a.isOverflow, isOversized = _a.isOversized;
    var tagContent = (React.createElement(BiLink, { key: tag.name, href: tag.url, className: classnames(tagStyle['tag'], isOverflow && tagStyle['overflow']), biData: {
            evid: BiEventType.TAG_CLICK,
            tag_text: tag.name,
            link_url: tag.url,
        } },
        React.createElement("span", { className: tagStyle['tag-text'] }, tag.name)));
    if (isOversized) {
        return (React.createElement(TextTooltipOnHover, { textClassName: tagStyle['tooltip'], tooltipText: tag.name }, tagContent));
    }
    return tagContent;
};
Tag.displayName = 'Tag';
export default Tag;
//# sourceMappingURL=Tag.js.map